import { render, staticRenderFns } from "./StandardUserNavbar.vue?vue&type=template&id=357d7224&"
import script from "./StandardUserNavbar.vue?vue&type=script&lang=js&"
export * from "./StandardUserNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports